import { Clinic, getClinic } from './Clinics';
import { TABLES } from '@/utils/constants';
import { getRecord } from '@/utils/helpers/data';
import { CLINIC_GROUP_COLUMNS, ClinicGroup } from '@/utils/schema';

export type { ClinicGroup };
export const COLUMNS = CLINIC_GROUP_COLUMNS;

/**
 * Retrieves a single clinic group record by its code.
 * @param code - The code of the clinic to retrieve.
 * @returns The requested clinic group record or null if not found.
 * @throws Will throw an error if the retrieval fails.
 */
export const fetchClinicGroup = async (
  code: string
): Promise<ClinicGroup | null> => {
  return getRecord<ClinicGroup>(TABLES.CLINIC_GROUPS, COLUMNS.CODE, code);
};

/**
 * Retrieves all branch clinic records associated with a clinic group.
 * @param code - The code of the clinic.
 * @returns An array of branch clinic records associated with the clinic group.
 * @throws Will throw an error if the retrieval fails.
 */
export const fetchBranches = async (code: string): Promise<Clinic[]> => {
  const clinicGroup = await fetchClinicGroup(code);
  if (!clinicGroup) return [];

  const clinicPromises = clinicGroup.branch_clinic_ids.map((clinicId) =>
    getClinic(clinicId)
  );
  const clinics = await Promise.all(clinicPromises);

  return clinics.filter((clinic): clinic is Clinic => clinic !== null);
};
